import { render, staticRenderFns } from "./DetailTrx.vue?vue&type=template&id=9c5972be&"
import script from "./DetailTrx.vue?vue&type=script&lang=js&"
export * from "./DetailTrx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports